import { Button, TextField } from '@mui/material'
import * as React from 'react'
import { useRef } from 'react'
import { tsGetSampleRun } from '../../Typescript/API_Response'
import { useNavigate } from 'react-router-dom'
import { addSamplePath, sampleRunDisabled } from './SampleRunFns'
import { useFetchAnimalsInContainer } from '../../APIs/Hooks/AnimalHooks'
import { useGlobalContext } from '../../Contexts/GlobalTriggers'
import { delay } from '../../Functions/DelayFn'
import { useGetScreenCollection } from '../../APIs/Hooks/ScreenCollectionHooks'

function AddSampleToRun({
  sampleRun,
}: {
  sampleRun: tsGetSampleRun | undefined
}) {
  const navigate = useNavigate()
  const { playScanSound } = useGlobalContext()
  const containerRef = useRef<HTMLHeadingElement>(null)
  const { data: collection } = useGetScreenCollection(
    sampleRun?.runInfo?.ScreenCollectionID,
  )
  const { mutate: getAnimalsInContainer } = useFetchAnimalsInContainer(
    sampleRun,
    collection,
    containerRef,
  )
  if (
    sampleRun?.runInfo?.ScreenCollectionID &&
    collection &&
    collection.Collection?.Criteria !== '3'
  ) {
    return (
      <Button
        fullWidth
        variant="contained"
        color="primary"
        disabled={
          sampleRunDisabled(sampleRun) || !collection?.Collection?.Criteria
        }
        onClick={() => {
          navigate(addSamplePath(collection!.Collection.Criteria), {
            state: { sampleRun: sampleRun, collection: collection },
          })
        }}
      >
        Add Sample
      </Button>
    )
  } else {
    return (
      <TextField
        label="Container ID"
        id="containerID"
        autoFocus
        disabled={sampleRunDisabled(sampleRun)}
        helperText={'Enter container ID from which to add samples'}
        onKeyDown={(e: any) => {
          if (e.key === 'Enter' || e.key === 'NumpadEnter') {
            playScanSound(true)
            delay(500).then(() => getAnimalsInContainer(e.target.value))
          }
        }}
        fullWidth
        ref={containerRef}
      />
    )
  }
}

export default AddSampleToRun
